function flattenList(list) {
  let newArray = [];

  function getNext(taskList, parent) {
    for (let i = 0; i < taskList.length; i++) {
      newArray.push({
        id: taskList[i].id,
        p: parent,
        c: taskList[i].collapsed
      });
      if (taskList[i].tasks != []) {
        getNext(taskList[i].tasks, taskList[i].id);
      }
    }
  }

  getNext(list, 0);
  return newArray;
}
function unflattenList(list, initialParent) {
  let newArray = [];

  function pushThroughStack(newData, stack) {
    let subArray = newArray; // works because objects are pass by reference
    for (let i = 0; i < stack.length; i++) {
      if (i == stack.length - 1) {
        subArray.push({
          id: newData.id,
          collapsed: newData.c,
          tasks: []
        });
        stack[stack.length - 1] = subArray.length - 1; // increments stack
        stack.push(0); // since we've pushed a new empty list
        return stack;
      } else {
        subArray = subArray[stack[i]].tasks;
      }
    }
  }

  let stack = [0];
  let parentStack = [initialParent];
  // iterate list
  for (let i = 0; i < list.length; i++) {
    // pop stack to match list
    for (let j = stack.length - 1; j >= 0; j--) {
      if (list[i].p == parentStack[j]) {
        // child of focused parent
        // pop back through parentStack and then push
        parentStack = parentStack.slice(0, j + 1);
        parentStack.push(list[i].id); // now becomes a parent
        stack = pushThroughStack(list[i], stack.slice(0, j + 1));
        break;
      }
    }
  }
  return newArray;
}
export { flattenList, unflattenList };
